var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5C12.0899 14.5 15 11.5899 15 8C15 4.41015 12.0899 1.5 8.5 1.5M8.5 14.5C4.91015 14.5 2 11.5899 2 8C2 4.41015 4.91015 1.5 8.5 1.5M8.5 14.5C9.8054 14.5 10.8636 11.5899 10.8636 8C10.8636 4.41015 9.8054 1.5 8.5 1.5M8.5 14.5C7.1946 14.5 6.13636 11.5899 6.13636 8C6.13636 4.41015 7.1946 1.5 8.5 1.5M2.59091 5.63636H14.4091M2.59091 9.77273H14.4091",
    stroke: "#5C5C5C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.cde4e446a40784e1ef4d1cac8e1bcae0.svg";
export { ForwardRef as ReactComponent };